// Aktionsmodul: Vorgang an ein Team übergeben (statt an eine Einzelperson).
// v1: liefert nur einen Hinweis-Entwurf (interner Kommentar + Historie) — eine
// echte Team-Zuweisung folgt später (tickets hat aktuell kein team_id-Feld).
import { supabase } from '../../supabase/client';
import type { AktionEntwurf, AktionKontext, AktionModul, TicketAktion } from '../types';

export function erzeugen(ctx: AktionKontext): AktionEntwurf | null {
  if (ctx.ticket.bearbeiter_vorschlag_typ !== 'team') return null;
  const teamName = ctx.stammdaten?.teamName;
  if (!teamName) return null;

  return {
    typ: 'an_team',
    freigabe_erforderlich: false,
    ist_rechtlich_sensibel: false,
    empfaenger: null,
    empfaenger_kontakt_id: null,
    betreff: null,
    entwurf_text: `Vorgang an Team ${teamName} übergeben`,
    payload: { team_id: ctx.ticket.bearbeiter_vorschlag_id ?? null, team_name: teamName },
    ki_confidence: ctx.ticket.ki_confidence ?? null,
  };
}

// Dünner Supabase-Wrapper (Konvention: nicht unit-getestet). Systemaktion — ausfuehren()
// erhält laut AktionModul-Signatur keinen benutzerId-Parameter, benutzer_id/autor_id
// bleiben daher null.
export async function ausfuehren(aktion: TicketAktion): Promise<{ ok: boolean; fehler?: string }> {
  const teamName = typeof aktion.payload?.team_name === 'string' ? aktion.payload.team_name : '';

  const { error: historieError } = await supabase.from('ticket_historie').insert({
    ticket_id: aktion.ticket_id,
    benutzer_id: null,
    aktion: 'an_team',
    neuer_wert: `An Team ${teamName} übergeben`,
  });
  if (historieError) return { ok: false, fehler: historieError.message };

  const { error: kommentarError } = await supabase.from('ticket_kommentare').insert({
    ticket_id: aktion.ticket_id,
    autor_id: null,
    inhalt: aktion.entwurf_text ?? 'An Team übergeben',
    ist_intern: true,
  });
  if (kommentarError) return { ok: false, fehler: kommentarError.message };

  return { ok: true };
}

export const anTeamModul: AktionModul = { typ: 'an_team', erzeugen, ausfuehren };
